module.exports = __webpack_public_path__ + "static/media/premiere.227407a4.svg";